import { Gift, Users } from "lucide-react";
import { pad, useMemberCount } from "@/lib/launchOffer";

const UNITS = [["d", "Days"], ["h", "Hours"], ["m", "Minutes"], ["s", "Seconds"]];

// Hero countdown tiles for the free launch period.
export const HeroCountdown = ({ left, label }) => {
  const members = useMemberCount();
  return (
  <div className="fade-in-3 mb-8" data-testid="hero-countdown">
    <p className="flex items-center gap-2 text-terracotta-light font-heading font-bold text-sm uppercase tracking-widest mb-3">
      <Gift className="w-4 h-4" /> Free business early access ends in
    </p>
    <div className="flex gap-2 sm:gap-3" role="timer" aria-live="off">
      {UNITS.map(([k, label]) => (
        <div
          key={k}
          className="w-[4.5rem] sm:w-24 rounded-2xl bg-cream/10 border border-cream/20 backdrop-blur-md py-3 text-center shadow-lg"
          data-testid={`hero-countdown-${k}`}
        >
          <span key={left[k]} className="block text-3xl sm:text-4xl font-black text-cream tabular-nums leading-none animate-in slide-in-from-top-1 duration-200">
            {k === "d" ? left[k] : pad(left[k])}
          </span>
          <span className="block mt-1.5 text-[10px] sm:text-xs font-bold uppercase tracking-wider text-cream/70">{label}</span>
        </div>
      ))}
    </div>
    <p className="mt-3 text-sm text-cream/80" data-testid="hero-countdown-note">
      Vendors, Event Creators &amp; Marketplace sellers: list before <strong className="text-cream">{label}</strong>, no payment needed.
    </p>
    {members && (
      <p className="mt-2 inline-flex items-center gap-2 text-sm font-semibold text-cream" data-testid="hero-member-count">
        <Users className="w-4 h-4 text-terracotta-light" /> Join {members} members already on Compass Kids
      </p>
    )}
  </div>
  );
};
